<template>
    <div>
        <div class="scanpage" v-if="index===0">
            <div class="scan">
                <div class="icon flex row-center">📋</div>
                <div class="tcenter">
                    <div class="title">{{inform.examName}}</div>
                    <div class="txt">请确认以下信息后开始签到</div>
                    <!-- <div class="txt">考试时长：{{form.answerDuration || 0}}分钟 | 题目数量：{{form.questions.length || 0}}题 | 满分：{{form.totalScore || 0}}分</div> -->
                </div>
                <van-form @submit="onSubmit">
                    <div class="upiden">
                        <div class="uptit tcenter">📌 签到</div>
                        <van-field v-model="takerName" name="takerName" label="姓名" placeholder="姓名" :rules="[{ required: true, message: '请填写姓名' }]"/>
                        <van-field v-model="takerPhone" name="takerPhone" label="手机号" placeholder="手机号" type="tel" maxlength="11" :rules="[{ required: true, message: '请填写手机号' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }]"/>
                        <van-field :value="examRegionText" name="examRegion" label="所属区域" placeholder="请选择所属区域" readonly is-link @click="showRegionPicker=true" :rules="[{ validator: examRegionValidator, message: '请选择所属区域' }]"/>
                        <van-field name="orgType" label="门店/总部" :value="orgType" :rules="[{ required: inform.orgTypeRequired==1?true:false, message: '请选择门店/总部' }]">
                            <template slot="input">
                                <van-radio-group v-model="orgType" direction="horizontal">
                                    <van-radio name="1">总部</van-radio>
                                    <van-radio name="2">门店</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-field v-if="orgType!='2'" :value="orgNameText" name="orgName" label="总部名称" placeholder="请选择总部名称" readonly is-link @click="showOrgPicker=true" :rules="[{ validator: orgNameValidator, message: '请选择总部名称' }]"/>
                        <van-field v-if="orgType!='1'" v-model="shop" name="shop" label="门店名称" placeholder="请选择门店" readonly is-link @click="showShopPicker=true" :rules="[{ required: inform.orgNameRequired==1, message: '请选择门店' }]"/>
                        <van-field v-model="dept" name="dept" label="部门" placeholder="请参考钉钉信息" :rules="[{ required: inform.departmentRequired==1?true:false, message: '请填写部门' }]"/>
                        <van-field v-model="position" name="position" label="职位" placeholder="请参考钉钉信息" :rules="[{ required: inform.positionRequired==1?true:false, message: '请填写职位' }]"/>
                        <van-field name="gender" label="性别" :value="gender" :rules="[{ required: inform.genderRequired==1?true:false, message: '请选择性别' }]">
                            <template slot="input">
                                <van-radio-group v-model="gender" direction="horizontal">
                                    <van-radio name="1">男</van-radio>
                                    <van-radio name="2">女</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                    </div>
                    <van-button block type="info" style="border-radius: 6px;margin-bottom: 10px;" native-type="submit">✅ 确认信息，开始签到</van-button>
                </van-form>
                <van-popup v-model="showShopPicker" position="bottom">
                    <van-picker show-toolbar value-key="shopName" :columns="shopColumns" @confirm="onShopConfirm" @cancel="showShopPicker=false"/>
                </van-popup>
                <van-popup v-model="showRegionPicker" position="bottom">
                    <van-picker show-toolbar :columns="regionColumns" @confirm="onRegionConfirm" @cancel="showRegionPicker=false"/>
                </van-popup>
                <van-popup v-model="showOrgPicker" position="bottom">
                    <van-picker show-toolbar :columns="orgColumns" @confirm="onOrgConfirm" @cancel="showOrgPicker=false"/>
                </van-popup>
            </div>
        </div>
        <div class="scanpage" v-if="index==1">
            <div class="scan">
                <div class="icon flex row-center">📋</div>
                <div class="tcenter">
                    <div class="title">{{inform.examName}}</div>
                    <div class="txt">请确认以下信息后开始考试</div>
                    <div class="txt">考试时长：{{inform.answerDuration || 0}}分钟 | 题目数量：{{inform.questionCount || 0}}题 | 满分：{{inform.totalScore || 0}}分</div>
                </div>
                <div class="infomate" v-if="inform.switchScreenCheck==1">
                    <span>⚠️</span>
                    <span>考试期间请勿切换页面，切屏超过 {{inform.switchScreenLimit || 0}} 次将自动交卷。<strong>到时系统自动交卷并计算分数。</strong>答题进度每 答一题 自动保存。</span>
                </div>
                <van-form @submit="getview" v-if="index==1">
                    <!-- <div class="upiden">
                        <div class="uptit tcenter">📌 签到</div>
                        <van-field v-model="takerName" name="takerName" label="姓名" placeholder="姓名" :rules="[{ required: true, message: '请填写姓名' }]"/>
                        <van-field v-model="takerPhone" name="takerPhone" label="手机号" placeholder="手机号" :rules="[{ required: true, message: '请填写手机号' }]"/>
                    </div> -->
                    <div class="identity" style="margin-top:16px">
                        <div class="row">
                            <span class="label">姓名：</span>
                            <span class="value">{{takerName}}</span>
                        </div>
                        <div class="row">
                            <span class="label">手机号：</span>
                            <span class="value">{{takerPhone}}</span>
                        </div>
                        
                        <div class="row">
                            <span class="label">所属区域：</span>
                            <span class="value">{{examRegionText}}</span>
                        </div>
                        <div class="row">
                            <span class="label">{{orgType=='1'?'总部':'门店'}}名称：</span>
                            <span class="value">{{orgType=='1'?orgNameText:shop}}</span>
                        </div>
                        <div class="row">
                            <span class="label">部门：</span>
                            <span class="value">{{dept}}</span>
                        </div>
                        <div class="row">
                            <span class="label">职位：</span>
                            <span class="value">{{position}}</span>
                        </div>
                        <div class="row">
                            <span class="label">性别：</span>
                            <span class="value">{{gender==1?'男':'女'}}</span>
                        </div>
                    </div>
                    <div class="desc">
                        <div>✅ 您在白名单内，可以参加考试</div>
                        <div>✅ 当前时间在考试开放时间段内</div>
                        <div>✅ 本月已考 {{examCount}} 次，剩余 {{examTimesLimit}} 次</div>
                    </div>

                    <van-button block type="info" style="border-radius: 6px;margin-bottom: 10px;" native-type="submit">✅ 确认信息，开始考试</van-button>
                </van-form>
            </div>    
        </div>
        <div v-if="index==2">
            <van-nav-bar :title="'第 '+(curorder+1)+'/'+form.questionCount+' 题'" left-arrow @click-left="onClickLeft"/>
            <div class="scanques" v-if="form.questions && form.questions.length">
                <div class="count">⏱ 剩余时间：{{remainText}}</div>
                <div class="plan flex row-between">
                    <span>📊 已作答 {{answeredCount}}/{{form.questions.length}} 题</span>
                    <span v-if="inform.switchScreenCheck==1">🛡️ 切屏 {{switchCount}}/{{inform.switchScreenLimit || 0}} 次</span>
                </div>
                <div class="answer-card">
                    <div class="item flex row-center" :class="{answered:item.answers.length>0,current:nindex==curorder}" v-for="(item,nindex) in form.questions" :key="nindex" @click="curorder=nindex">{{nindex+1}}</div>
                </div>
                <div class="question" v-if="form.questions.length>0">
                    <span class="num">第 {{curorder+1}} 题</span>
                    <span class="stag" :class='{blue:form.questions[curorder].questionType==1,green:form.questions[curorder].questionType==3}'>{{form.questions[curorder].questionTypeName}}</span>
                    <span class="stag score">{{form.questions[curorder].questionScore}}分</span>
                </div>
                <div class="content">{{form.questions[curorder].questionContent}}</div>
                <div class="option-item" v-for="(item,nindex) in form.questions[curorder].options" :key="nindex" :class="{selected:form.questions[curorder].answers.includes(item.optionLabel)}" @click="select(nindex)">
                    <span class="optlet">{{item.optionLabel}}</span>
                    <span class="optext">{{item.optionContent}}</span>
                </div>

                <div class="exam-nav flex row-between">
                    <van-button :type="curorder==0?'default':'info'" style="width:30%;border: 1px solid #d9d9d9;border-radius: 6px;" @click="pre()">‹ 上一题</van-button>
                    <van-button :type="curorder==form.questions.length-1?'default':'info'" style="width:30%;border: 1px solid #d9d9d9;border-radius: 6px;" @click="next()">下一题 ›</van-button>
                </div>

                <van-button block type="primary" style="border-radius: 6px;" @click="confirmSubmit()">✅ 确认交卷</van-button>
            </div>
        </div>
        <div v-if="index==3">
            <van-nav-bar title="确认交卷" left-arrow @click-left="onClickLeft"/>
            <div class="scanques tcenter">
                <div class="sicon">📝</div>
                <div class="stit">确认交卷？</div>
                <div class="txt m-b-24">交卷后考卷将关闭，无法再修改答案</div>
                <div class="count">
                    <div class="ctit">⚠️ 您还有未完成的题目</div>
                    <div class="flex row-between">
                        <div class="flex-1">
                            <div class="cnum">{{answeredCount}}</div>
                            <div class="txt">已作答</div>
                        </div>
                        <div class="flex-1">
                            <div class="cnum cred">{{unansweredCount}}</div>
                            <div class="txt">未作答</div>
                        </div>
                    </div>
                </div>
                <van-button block type="primary" style="border-radius: 6px;margin-bottom: 10px;" @click="submit()">✅ 确认交卷</van-button>
                <van-button block type="default" style="border: 1px solid #d9d9d9;border-radius: 6px;" @click="index=2">返回继续答题</van-button>
            </div>
        </div>
        <div v-if="index==4">
            <van-nav-bar title="考试结果"/>
            <div class="scanques tcenter">
                <div class="qscore">{{actualScore || 0}}</div>
                <div class="txt">分 / 满分 {{form.totalScore || 0}} 分</div>
                <div class="pass" :class="{passred:!passOrNot}">{{passOrNot?'🎉 恭喜通过！':'😢 未通过'}}</div>
                <div class="passmeta flex row-between">
                    <div class="flex-1">
                        <div class="cnum">{{correctCount || 0}}/{{form.questions.length || 0}}</div>
                        <div class="txt">答对题数</div>
                    </div>
                    <div class="flex-1">
                        <div class="cnum cred">{{usedTimeText}}</div>
                        <div class="txt">答题用时</div>
                    </div>
                    <div class="flex-1">
                        <div class="cnum cred">0次</div>
                        <div class="txt">切屏记录</div>
                    </div>
                </div>
                <div v-if="inform.showAnswerAfter==1">
                    <div class="review">📋 题目回顾</div>
                    <div class="bbox" v-for="(item,nindex) in wrongQuestions" :key="nindex">
                        <div class="flex row-between">
                            <div>
                                <span class="stag" :class='{blue:item.questionType==1,green:item.questionType==3}'>{{item.questionTypeName}}</span>
                                <span class="stag score">{{item.score}}分</span>
                            </div>
                            <span class="stag blue" :class="{redb:item.score==0}">{{item.score==item.questionScore?'✅ 答对':'❌ 答错'}}</span>
                        </div>
                        <div class="content">{{item.questionContent}}</div>
                        <div class="option-item" v-for="(opt,nindex) in item.options" :key="nindex" :class="{selected:isRightOption(item,opt),sred:isWrongOption(item,opt)}">
                            <div class="optmain">
                                <span class="optlet">{{opt.optionLabel}}</span>
                                <span class="optext">{{opt.optionContent}}</span>
                            </div>
                            <template v-if="inform.showCorrectAnswer==1 && isWrongQuestion(item)">
                                <span class="tip twrong" v-if="isWrongOption(item,opt)">❌你的选择</span>
                                <span class="tip tright" v-if="isCorrectOption(item,opt)">✅正确答案</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <van-popup v-model="show" round position="center" style="width:70%;">
            <div class="pbox tcenter">
                <div class="picon">⏰</div>
                <div class="sptit">考试时间已到</div>
                <div class="sptxt">系统已自动交卷并计算分数</div>
                <van-button block type="info" style="border-radius: 6px;" @click="show=false">查看成绩</van-button>
            </div>
        </van-popup>

        <van-popup v-model="showscreen" round position="center" style="width:70%;">
            <div class="pbox tcenter redwarning">
                <div class="picon">⚠️</div>
                <div class="sptit">检测到切屏！</div>
                <div class="sptxt">您已切屏 {{switchCount || 0}} 次，剩余 {{inform.switchScreenLimit-(switchCount || 0)}} 次
                    <br>超过限制将自动交卷
                </div>
                <van-button block type="info" style="border-radius: 6px;" @click="showscreen=false">我知道了</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi'
// import { dingAutoLogin, isInDingTalk, getPlatform } from '@/utils/dingAuth'
export default {
  name: 'training',
  data () {
    return {
        id:this.$route.query.id,
        index:0,
        curorder:0,
        form:'',
        inform:'',
        startTime:0,
        deadline:0,
        leftSeconds:0,
        timer:null,
        platform:'',
        signInTime:'',
        takerName:'',
        takerPhone:'',
        examRegion:'',
        shop:'',
        takerSid:'',
        signanswers:[],
        actualScore:0,
        correctCount:0,
        passOrNot:'',
        usedSeconds:0,
        timeUp:false,
        wrongQuestions:[],
        switchScreenCount:'',
        switchCount:0,
        hiddenAt:0,
        showShopPicker:false,
        showRegionPicker:false,
        showOrgPicker:false,
        orgName:'',
        orgType:'',
        dept:'',
        position:'',
        regionColumns:[{text:'北京地区',value:'1'},{text:'华东地区',value:'2'},{text:'山东地区',value:'3'}],
        orgColumns:[{text:'集团总部',value:'1'},{text:'北京总部',value:'2'},{text:'山东总部',value:'3'},{text:'华东总部',value:'4'}],
        shopColumns:[{
            shopName:'新辰里（亚运村店）',
        },{
            shopName:'新辰里（酒仙桥店）',
        },{
            shopName:'新辰里（学清路店）',
        },{
            shopName:'新辰天地（大兴店）',
        },{
            shopName:'华堂新辰汇',
        },{
            shopName:'V-HUB',
        },{
            shopName:'杨庄店',
        },{
            shopName:'洋桥店',
        }],
        examCount:0,
        examTimesLimit:0,
        show:false,
        showscreen:false,
        draftAnswers:[],
        question:'',
        // shoplist:[{
        //     shopName:'新辰里（亚运村店）',
        // },{
        //     shopName:'新辰里（酒仙桥店）',
        // },{
        //     shopName:'新辰里（学清路店）',
        // },{
        //     shopName:'新辰天地（大兴店）',
        // },{
        //     shopName:'华堂新辰汇',
        // },{
        //     shopName:'V-HUB',
        // },{
        //     shopName:'杨庄店',
        // },{
        //     shopName:'洋桥店',
        // }],
        gender:'',
        orgName:'',
        orgType:'',
        dept:'',
        position:'',
    }
  },
  computed:{
    remainText(){
        // 未签到时不显示倒计时
        if(!this.startTime) return '--:--'
        let sec=this.leftSeconds>0?this.leftSeconds:0
        let m=Math.floor(sec/60)
        let s=sec%60
        return (m<10?'0':'')+m+':'+(s<10?'0':'')+s
    },
    orgNameText(){
        for(let i=0;i<this.orgColumns.length;i++){
            if(this.orgColumns[i].value==this.orgName) return this.orgColumns[i].text
        }
        return ''
    },
    examRegionText(){
        for(let i=0;i<this.regionColumns.length;i++){
            if(this.regionColumns[i].value==this.examRegion) return this.regionColumns[i].text
        }
        return ''
    },
    usedTimeText(){
        let total=Number(this.usedSeconds)||0
        let m=Math.floor(total/60)
        let s=total%60
        if(m>0) return m+'分钟'+s+'秒'
        return s+'秒'
    },
    answeredCount(){
        if(!this.form||!this.form.questions) return 0
        let n=0
        for(let i=0;i<this.form.questions.length;i++){
            if(this.form.questions[i].answers&&this.form.questions[i].answers.length>0) n++
        }
        return n
    },
    unansweredCount(){
        if(!this.form||!this.form.questions) return 0
        return this.form.questions.length-this.answeredCount
    }
  },
  created(){
    document.title=''
  },
  watch:{
    examRegion(val){
        // 选择集团时清空所属店铺
        if(val=='集团'){
            this.shop=''
        }
        this.buildOrgColumns()
        this.setOrgByRegion()
    },
    orgType(val){
        // 切换机构类型时清空被隐藏的那一项，避免提交脏数据
        if(val=='1'){
            this.shop=''
        }else if(val=='2'){
            this.orgName=''
        }
        this.setOrgByRegion()
    }
  },
  mounted(){
    let that=this;
    let newcorpId='dingdf0fbde87223830a35c2f4657eb6378f'
    // that.platform=getPlatform()
    // if (isInDingTalk()) {
    //     dd.ready(() => {
    //         dd.runtime.permission.requestAuthCode({
    //             corpId: newcorpId,
    //             onSuccess: (es) => {
    //                 // that.$dialog.alert({ message: 'tmp_auth_code：' + es.code })
    //                 that.$axios.get(process.env.API_HOST+"sysmanager/vue/dingtalk/corp/auth/"+newcorpId+"?authCode="+es.code).then((res) => {
    //                     that.$dialog.alert({ message: '获取信息成功'})
    //                     if(res.data.success){
    //                         that.$dialog.alert({ message: '获取信息成功：' + JSON.stringify(res.data) })
    //                     }else{
    //                         that.$dialog.alert({ message:res.data.message})
    //                     }
    //                 }).catch((res) =>{
    //                     that.$dialog.alert({ message: '获取信息失败：' + JSON.stringify(res) })
    //                 });
    //                 // resolve(res.code)
    //             },
    //             onFail: (err) => {
    //                 that.$dialog.alert({ message: '获取 code 失败：' + JSON.stringify(err) })
    //                 // reject(err)
    //             }
    //         })
    //     })
    // }else{
    //     that.$dialog.alert({ message: '不在钉钉中：'+this.platform })
    // }
    // that.getinfo()
    that.getexam()
    // that.getview()
    document.addEventListener('visibilitychange', this.onVisibilityChange)
    window.addEventListener('pagehide', this.onPageHide)
  },
  beforeDestroy(){
    this.stopCountdown()
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    window.removeEventListener('pagehide', this.onPageHide)
  },
  methods:{
    onVisibilityChange(){
        if(document.visibilityState=='hidden') this.handleLeave()
    },
    onPageHide(){
        this.handleLeave()
    },
    examRegionValidator(){
        // 仅当接口要求所属区域必填（examRegionRequired==1）时才做必填校验
        if(this.inform && this.inform.examRegionRequired==1){
            return !!this.examRegion
        }
        return true
    },
    orgNameValidator(){
        if(this.inform && this.inform.orgNameRequired==1){
            return !!this.orgName
        }
        return !!this.orgName
    },
    buildOrgColumns(){
        // 按所属区域生成可选的机构名称（总部）
        let map={
            '北京地区':[{text:'集团总部',value:'1'},{text:'北京总部',value:'4'}],
            '华东地区':[{text:'华东总部',value:'3'}],
            '山东地区':[{text:'山东总部',value:'2'}]
        }
        let list=map[this.examRegionText]
        this.orgColumns=list||[{text:'集团总部',value:'1'},{text:'山东总部',value:'2'},{text:'华东总部',value:'3'}]
        this.orgName=''
    },
    setOrgByRegion(){
        // 机构类型为总部时，按所属区域带出默认机构名称
        if(this.orgType!='1') return
        let nameMap={'北京地区':'集团','华东地区':'华东总部','山东地区':'山东总部'}
        let target=nameMap[this.examRegionText]
        if(!target) return
        for(let i=0;i<this.orgColumns.length;i++){
            if(this.orgColumns[i].text==target){
                this.orgName=this.orgColumns[i].value
                break
            }
        }
    },
    onOrgConfirm(value){
        // 对象数组返回整条数据，取 value 作为提交值
        this.orgName=(value&&value.value!==undefined)?value.value:value
        this.showOrgPicker=false
    },
    onRegionConfirm(value){
        // 对象数组返回整条数据，取 value 作为提交值
        this.examRegion=(value&&value.value!==undefined)?value.value:value
        console.log(this.examRegion)
        this.showRegionPicker=false
    },
    onShopConfirm(value){
        // 对象数组时返回整条数据，取 shopName 展示
        this.shop=(value&&value.shopName)?value.shopName:value
        this.showShopPicker=false
    },
    handleLeave(){
        // 未开启切屏检测或不在答题页时忽略
        if(!this.inform||this.inform.switchScreenCheck!=1) return
        if(this.index!=2) return
        let now=Date.now()
        // 防抖：同一次切屏只计一次
        if(now-this.hiddenAt<1000) return
        this.hiddenAt=now
        this.switchCount++
        let limit=Number(this.inform.switchScreenLimit)||0
        if(limit>0&&this.switchCount>=limit){
            // this.$toast('切屏次数已达上限，自动交卷')
            this.$dialog.alert({ message:'切屏次数已达上限，自动交卷'})
            this.submit()
        }else{
            this.showscreen=true
            this.saveAnswer(this.question)
            // this.$toast('切屏 '+this.switchCount+'/'+limit+' 次')
        }
    },
    getinfo(){
        let that=this;
        that.$axios.get(process.env.API_HOST+"sso/applets/member/shop/queryList?superiorShopSid=21001").then((res) => {
            if(res.data.success){
                // 按 shopSid 升序排列，值越小越靠前
                that.shopColumns=(res.data.data||[]).slice().sort(function(a,b){
                    return (Number(a.shopSid)||0)-(Number(b.shopSid)||0)
                })
            }else{
                that.$dialog.alert({ message:res.data.message})
            }
        }).catch((res) =>{
        });  
    },
    onSubmit(form){
        let that=this;
        form.examSid=that.id
        form.orgName=that.orgNameText
        form.examRegion=that.examRegion
        form.gender=that.gender==''?0:that.gender
        that.$axios.post(process.env.API_HOST+"training/vue/train/exam/taker/sign-in",form).then((res) => {
            if(res.data.success){
                that.takerSid=res.data.data.sid
                that.examCount=res.data.data.examCount || 0
                that.examTimesLimit=Number(res.data.data.examTimesLimit)-Number(res.data.data.examCount)
                // that.examTimesLimit=res.data.examTimesLimit || 0
                that.index=1
                // that.getstart(form)
                // that.signanswers=res.data.data.answers||[]
                // that.fillAnswers()
                // that.index=2
                // that.beginCountdown(that.signInTime)
                // that.getanswer()
            }else{
                that.$dialog.alert({ message:res.data.message})
            }
        }).catch((res) =>{
            console.log('这里这里',res)
        });
        
        console.log('submit', form);
    },
    onStart(){
        let that=this;
        let form={
            examSid:that.id,
            takerSid:that.takerSid,
            takerName:that.takerName,
            takerPhone:that.takerPhone,
            shop:that.shop,
            region:that.examRegion,
        }
        that.$axios.post(process.env.API_HOST+"training/vue/train/exam/taker/start-answer",form).then((res) => {
            if(res.data.success){
                that.signInTime=res.data.data.startTime
                that.signanswers=res.data.data.answers||[]
                that.draftAnswers=res.data.data.draftAnswers || []
                that.fillAnswers()
                that.index=2
                that.beginCountdown(that.signInTime)
            }else{
                that.$dialog.alert({ message:res.data.message})
            }
        }).catch((res) =>{
            console.log('这里这里',res)
        });
    },

    getanswer(){
        let that=this;
        that.$axios.get(process.env.API_HOST+"training/vue/train/exam/taker/"+that.takerSid+"/score-detail/all").then((res) => {
            if(res.data.success){
                // 只取 attemptNo 最大（最近一次作答）的记录
                let list=res.data.data.allQuestions || []
                let maxNo=0
                for(let i=0;i<list.length;i++){
                    let no=Number(list[i].attemptNo)||0
                    if(no>maxNo) maxNo=no
                }
                let latest=[]
                for(let i=0;i<list.length;i++){
                    if((Number(list[i].attemptNo)||0)===maxNo) latest.push(list[i])
                }
                that.wrongQuestions=latest
                console.log('题目回顾', maxNo, latest)
            }else{
                that.$dialog.alert({ message:res.data.message})
            }
        }).catch((res) =>{
            
        });
    },
    onClickLeft(){
        if(this.index==3){
            this.index=2
            return
        }
        this.$router.back()
    },
    confirmSubmit(){
        // 倒计时未结束且还有未作答的题目，进入 index==3 二次确认
        if(this.leftSeconds>0&&this.answeredCount<this.form.questions.length){
            this.index=3
            return
        }
        this.submit()
    },
    submit(){
        let that=this;
        // 汇总所有题目为 answers:[{questionSid, selectedAnswer}]
        let answers=[]
        if(that.form&&that.form.questions){
            for(let i=0;i<that.form.questions.length;i++){
                let question=that.form.questions[i]
                answers.push({
                    questionSid:question.questionSid,
                    selectedAnswer:(question.answers||[]).toString()
                })
            }
        }
        let form={
            takerPhone:that.takerPhone,
            takerName:that.takerName,
            takerSid:that.takerSid,
            examSid:that.id,
            answers:answers,
            shop:that.shop,
            region:that.examRegion,
        }
        that.$axios.post(process.env.API_HOST+"training/vue/train/exam/submit",form).then((res) => {
            if(res.data.success){
                that.actualScore=res.data.data.actualScore || 0
                that.correctCount=res.data.data.correctCount || 0
                that.passOrNot=res.data.data.passOrNot
                // 接口返回单位为秒，保留原始秒数，展示时再格式化
                that.usedSeconds=Number(res.data.data.usedSeconds)||0
                that.stopCountdown()
                that.index=4
                that.getanswer()
                if(that.timeUp){
                    that.show=true
                    // that.$dialog.alert({ message: '考试时间到，已自动交卷'})
                }
            }else{
                that.$dialog.alert({ message:res.data.message})
            }
        }).catch((res) =>{
            console.log('这里这里',res)
        });

        
    },
    pre(){
        if(this.curorder==0) return
        this.curorder--
    },
    next(){
        if(this.curorder==this.form.questions.length-1) return
       this.curorder++ 
    },
    select(index){
        let question=this.form.questions[this.curorder]
        let option=question.options[index]
        if(!question.answers) question.answers=[]
        let pos=question.answers.indexOf(option.optionLabel)
        if(question.questionType==1){
            // 单选题：只能选一个，再次点击取消
            question.answers = pos>-1 ? [] : [option.optionLabel]
        }else{
            // 非单选题（多选等）：可多选，再次点击取消
            if(pos>-1){
                question.answers.splice(pos,1)
            }else{
                question.answers.push(option.optionLabel)
                question.answers.sort()
            }
        }
        this.question=question
        this.saveAnswer(question)
    },
    saveAnswer(question){
        console.log("切屏提交")
        // 每答一次题保存一次，只保存不交卷
        let that=this;
        let form={
            takerSid:that.takerSid,
            examSid:that.id,
            questionSid:question.questionSid,
            selectedAnswer:question.answers.toString(),
            switchScreenCount:that.switchCount || null
        }
        that.$axios.post(process.env.API_HOST+"training/vue/train/exam/save-answer",form).then((res) => {
            // if(res.data.success){
            //     that.takerSid=res.data.data.sid
            //     that.signInTime=res.data.data.signInTime
            //     that.$toast('签到成功')
            //     console.log('答案已保存',question.id,question.answers)
            // }
        }).catch((error) =>{
        });
    },
    splitAnswer(val){
        if(!val) return []
        return String(val).split(',').filter(function(v){ return v })
    },
    getUserAnswer(question){
        // 兼容接口返回 selectedAnswer，或本地维护的 answers 数组
        if(question.selectedAnswer!==undefined&&question.selectedAnswer!==null&&question.selectedAnswer!==''){
            return question.selectedAnswer
        }
        return (question.answers||[]).toString()
    },
    isCorrectOption(question,option){
        // 该选项属于正确答案（不论用户是否选中）
        return this.splitAnswer(question.correctAnswer).indexOf(option.optionLabel)>-1
    },
    isWrongQuestion(question){
        // 未得满分即视为作答有误
        return !(question.score==question.questionScore)
    },
    isRightOption(question,option){
        // 用户选中且属于正确答案
        let sel=this.splitAnswer(this.getUserAnswer(question))
        let right=this.splitAnswer(question.correctAnswer)
        return sel.indexOf(option.optionLabel)>-1&&right.indexOf(option.optionLabel)>-1
    },
    isWrongOption(question,option){
        // 用户选中但不属于正确答案
        let sel=this.splitAnswer(this.getUserAnswer(question))
        let right=this.splitAnswer(question.correctAnswer)
        return sel.indexOf(option.optionLabel)>-1&&right.indexOf(option.optionLabel)===-1
    },
    isSelected(index){
        if(!this.form.questions) return false
        let question=this.form.questions[this.curorder]
        if(!question||!question.options||!question.answers) return false
        return question.answers.indexOf(question.options[index].optionLabel)>-1
    },
    getexam(){
        let that=this;
        that.$axios.get(process.env.API_HOST+"training/vue/train/exam/"+that.id+'/taker-info','').then((res) => {
        if(res.status==200){
            that.inform=res.data.data
            document.title =that.inform.examName
        }
      }).catch((error) =>{
      });
    },
    getview(){
        let that=this;
        that.$axios.get(process.env.API_HOST+"training/vue/train/exam/"+that.id+'/paper','').then((res) => {
        if(res.status==200){
          that.form=res.data.data
          that.onStart()
          // 初始化每题的答案数组，保证 Vue 能监听到 answers 的变化
          if(that.form && that.form.questions){
            for(let i=0;i<that.form.questions.length;i++){
              that.$set(that.form.questions[i],'answers',that.form.questions[i].answers||[])
            }
          }
          that.fillAnswers()
        //   // 已签到过（如刷新页面）则以签到时间为起点继续倒计时，未签到不计时
        //   if(that.form.signInTime){
        //       that.signInTime=that.form.signInTime
        //       that.beginCountdown(that.signInTime)
        //   }
        }
      }).catch((error) =>{
      });
    },
    fillAnswers(){
        // 按 questionSid 匹配，把用户已选答案回填到对应题目
        // 优先用 draftAnswers（草稿/本次已选），为空时回退 signanswers
        if(!this.form||!this.form.questions) return
        let list=(this.draftAnswers&&this.draftAnswers.length)?this.draftAnswers:this.signanswers
        if(!list||!list.length) return
        for(let i=0;i<this.form.questions.length;i++){
            let question=this.form.questions[i]
            for(let j=0;j<list.length;j++){
                let saved=list[j]
                if(String(saved.questionSid)!==String(question.questionSid)) continue
                let val=saved.selectedAnswer!==undefined?saved.selectedAnswer:(saved.answer!==undefined?saved.answer:saved.answers)
                let arr=[]
                if(typeof val==='string'){
                    arr=val?val.split(','):[]
                }else if(val instanceof Array){
                    arr=val.slice()
                }
                this.$set(question,'answers',arr)
                break
            }
        }
    },
    beginCountdown(signInTime){
        // 以签到时间为起点，answerDuration（分钟）为时长推算截止时刻
        let start=this.toTimestamp(signInTime)
        if(!start||!this.form.answerDuration) return
        this.startTime=start
        this.deadline=start+(Number(this.form.answerDuration)||0)*60*1000
        this.startCountdown()
    },
    toTimestamp(val){
        // 兼容 2026-09-04 10:00:00 / 2026-09-04T10:00:00 / 秒级或毫秒级时间戳
        if(!val) return 0
        if(/^\d+$/.test(val)){
            let n=Number(val)
            return n<100000000000 ? n*1000 : n
        }
        let t=new Date(String(val).trim().replace(/-/g,'/')).getTime()
        if(!t) t=new Date(String(val).trim().replace(' ','T')).getTime()
        return t||0
    },
    startCountdown(){
        let that=this;
        that.stopCountdown()
        that.tickCountdown()
        // 已到时间的不必再起定时器
        if(that.leftSeconds<=0) return
        that.timer=setInterval(function(){
            that.tickCountdown()
        },1000)
    },
    tickCountdown(){
        let left=Math.round((this.deadline-Date.now())/1000)
        this.leftSeconds=left>0?left:0
        if(this.leftSeconds>0) return
        this.stopCountdown()
        // 时间到自动交卷，只触发一次
        if(this.timeUp) return
        this.timeUp=true
        if(this.index==2||this.index==3){
            this.submit()
        }
    },
    stopCountdown(){
        if(this.timer){
            clearInterval(this.timer)
            this.timer=null
        }
    },
  }
}   
</script>


<style scoped>
.pbox{
    padding: 32px;
}
.redwarning{
    background: #fff1f0;
    border: 2px solid #ff4d4f;
}
.redwarning .sptit{
    color: #ff4d4f;
}
.picon{
    font-size: 48px;
    margin-bottom: 16px;
}
.sptit{
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
}
.sptxt{
    font-size: 13px;
    color: #666;
    margin-bottom: 20px;
}
.m-b-24{
    margin-bottom: 24px;
}
.exam-nav{
    padding: 16px 0;
    border-top: 1px solid #f0f0f0;
    margin-top:24px;
}
.plan{
    font-size: 12px;
    color: #999;
    margin-bottom: 12px;
}
.num{
    font-size: 16px;
    font-weight: 600;
    color: #333;
}
.stag{
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    background: #f9f0ff;
    color: #722ed1;
}
.stag.score{
    color: #fa8c16;
    background: #fff7e6;
}
.stag.blue{
    background: #e6f4ff;
    color: #1677ff;
}
.stag.green{
    background: #f6ffed;
    color: #52c41a;
}
.stag.redb{
    background: #fff1f0;
    color: #ff4d4f;
}
.content{
    font-size: 15px;
    line-height: 1.8;
    margin-bottom: 16px;
    color: #333;
    margin-top:12px;
}
.answer-card{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
    padding: 12px;
    background: #fafafa;
    border-radius: 8px;
}
.answer-card .item{
    width: 32px;
    height: 32px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #666;
    cursor: pointer;
}
.answer-card .answered{
    background: #52c41a;
    color: #fff;
    border-color: #52c41a;
}
.answer-card .current{
    box-shadow: 0 0 0 2px #1677ff;
}
.scanpage{
    background-color: #ffffff;
}
.scan{
    box-sizing: border-box;
    padding: 40px 24px;
}
.scanques{
    box-sizing: border-box;
    padding: 16px;
}
.flex{
    display: flex;
}
.flex-1{
    flex:1;
}
.row-center{
    align-items: center;
    justify-content: center;
}
.row-between{
    align-items: center;
    justify-content: space-between;
}
.tcenter{
    text-align: center;
}
.icon{
    width: 80px;
    height: 80px;
    background: #1677ff;
    border-radius: 16px;
    font-size: 40px;
    margin: 0 auto 20px;
}
.title{
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
}
.txt{
    font-size: 13px;
    color: #999;
    line-height: 1.6;
}
.infomate{
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 16px;
    font-size: 13px;
    color: #ad6800;
    display: flex;
    gap: 8px;
    margin-top: 24px;
}
.upiden{
    background: #f0f5ff;
    border-radius: 12px;
    padding: 10px 0;
    margin: 24px 0 16px;
}
.uptit{
    font-size: 16px;
    color: #999;
    margin-bottom: 12px;
}
.upiden .van-cell{
    background: #f0f5ff;
}
.upiden input:-internal-autofill-selected{
    background-color: transparent !important;
}
.identity{
    background: #f0f5ff;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
}
.row{
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 14px;
}
.label {
    color: #666;
}
.desc{
    font-size: 12px;
    color: #999;
    margin-bottom: 16px;
    margin-top: 12px;
    text-align: left;
    line-height: 1.8;
}
.option-item{
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border: 1px solid #d9d9d9;
    border-radius: 12px;
    background: #fff;
    font-size: 15px;
    color: #333;
    margin-bottom: 12px;
    cursor: pointer;
    transition: all 0.2s;
}
.optlet{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #f5f5f5;
    color: #999;
    font-size: 13px;
    font-weight: 600;
    flex-shrink: 0;
}
.optext{
    flex: 1;
    line-height: 1.5;
}
.option-item.selected{
    background: #e6f4ff;
    border-color: #91caff;
}
.option-item.selected .optlet{
    background: #1677ff;
    color: #fff;
}
.optmain{
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
}
.option-item .tip{
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}
.option-item .twrong{
    color: #ff4d4f;
}
.option-item .tright{
    color: #52c41a;
}
.option-item.sred{
    background: #fff1f0;
}
.option-item.sred .optlet{
    background: #ff4d4f;
    color: #fff;
}
.count{
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #fa8c16;
    text-align: center;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 16px;
}
.ctit{
    font-size: 14px;
    color: #ad6800;
    margin-bottom: 8px;
}
.cnum{
    font-size: 20px;
    font-weight: 700;
    color: #52c41a;
}
.cred{
    color:#ff4d4f
}
.stit{
    font-size: 18px;
    margin-bottom: 8px;
    font-weight: bold;
}
.sicon{
    font-size: 48px;
    margin-bottom: 16px;
}
.passmeta{
    padding: 16px;
    background: #fafafa;
    border-radius: 8px;
    margin-bottom: 16px;
}
.passmeta .cnum{
    font-size: 18px;
    font-weight: 600;
    color: #333;
}
.qscore{
    font-size: 56px;
    font-weight: 700;
    color: #1677ff;
}
.pass{
    background: #f6ffed;
    color: #52c41a; 
    padding: 4px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    margin: 12px auto 32px;
    display: inline-block;
}
.passred{
    background: #ff4d4f;
    color: #fff;
}
.review{
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
}
.bbox{
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/view/training/index.vue